import { createApp } from "vue";
import App from "./App.vue";
import "./firebase";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { getAuth, onAuthStateChanged } from "firebase/auth";
const auth = getAuth();
import VueMasonry from "vue-masonry-css";
import { EmojiPickerPlugin } from "vue-emoji-picker";
import Vue3Lottie from "vue3-lottie";
// Vue.config.productionTip = false;
// Vue.use(VueMasonry);
// Vue.use(EmojiPickerPlugin);
let app;

onAuthStateChanged(auth, (user) => {
  if (!app) {
    app = createApp(App)
      .use(router)
      .use(vuetify)
      .use(store)
      .use(VueMasonry)
      .use(Vue3Lottie)
      .use(EmojiPickerPlugin);

    app.mount("#app");
    // app = new Vue({
    //   router,
    //   store,
    //   vuetify,
    //   VueMasonry,
    //   render: (h) => h(App),
    // }).$mount("#app");
  }

  if (user) {
    store.dispatch("fetchUserProfile", user);
  }
});

document.title = "Stix - Social Media Autopilot";
